import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { NgbNavModule, NgbAccordionModule, NgbDropdownModule, NgbModule, NgbPaginationModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

// Swiper Slider
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';

// Counter
import { CountToModule } from 'angular-count-to';

import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ClientLogoComponent } from './landing/index/client-logo/client-logo.component';
import { ServicesComponent } from './landing/index/services/services.component';
import { CollectionComponent } from './landing/index/collection/collection.component';
import { CtaComponent } from './landing/index/cta/cta.component';
import { DesignedComponent } from './landing/index/designed/designed.component';
import { PlanComponent } from './landing/index/plan/plan.component';
import { FaqsComponent } from './landing/index/faqs/faqs.component';
import { ReviewComponent } from './landing/index/review/review.component';
import { CounterComponent } from './landing/index/counter/counter.component';
import { WorkProcessComponent } from './landing/index/work-process/work-process.component';
import { TeamComponent } from './landing/index/team/team.component';
import { ContactComponent } from './landing/index/contact/contact.component';
import { FooterComponent } from './landing/index/footer/footer.component';
import { ScrollspyDirective } from './scrollspy.directive';

// NFT Landing 
import { MarketPlaceComponent } from './landing/nft/market-place/market-place.component';
import { WalletComponent } from './landing/nft/wallet/wallet.component';
import { FeaturesComponent } from './landing/nft/features/features.component';
import { CategoriesComponent } from './landing/nft/categories/categories.component';
import { DiscoverComponent } from './landing/nft/discover/discover.component';
import { TopCreatorComponent } from './landing/nft/top-creator/top-creator.component';

// Job Landing 
import { BlogComponent } from './landing/job/blog/blog.component';
import { ProcessComponent } from './landing/job/process/process.component';
import { CandidateComponent } from './landing/job/candidate/candidate.component';
import { JobFooterComponent } from './landing/job/job-footer/job-footer.component';
import { JobcategoriesComponent } from './landing/job/jobcategories/jobcategories.component';
import { FindjobsComponent } from './landing/job/findjobs/findjobs.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CRMRoutingModule } from '../pages/contacts/crm-routing.module';
import { ClientModalComponent } from './modals/client-modal/client-modal.component';
import { PicklistModalComponent } from './modals/picklist-modals/picklist-modal/picklist-modal.component';
import { RequisitionModalComponent } from './modals/requisition-modal/requisition-modal.component';
import { FileUploadModalComponent } from './modals/file-upload-modal/file-upload-modal.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { ArchwizardModule } from 'angular-archwizard';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { ColorPickerModule } from 'ngx-color-picker';
// Drop Zone
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

//Rich Text Editor
import { NgxSummernoteModule } from 'ngx-summernote';

import { UiSwitchModule } from 'ngx-ui-switch';
import { environment } from 'src/environments/environment';
import { FileManagementComponent } from './list-views/file-management/file-management.component';
import { DocumentViewModalComponent } from './modals/document-view-modal/document-view-modal.component';
import { RequisitionListComponent } from './list-views/requisition-list/requisition-list.component';
import { TimelineModalComponent } from './modals/timeline-modal/timeline-modal.component';
import { TimelineNoteModalComponent } from './modals/timeline-note-modal/timeline-note-modal.component';
import { CheckoutModalComponent } from './modals/checkout-modal/checkout-modal.component';
import { InvoiceLineItemModalComponent } from './modals/checkout-modal/invoice-line-item-modal.component';
import { CreditcardComponent } from './creditcard/creditcard.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TimeLineListComponent } from './list-views/time-line-list/time-line-list.component';
import { MultiSearchComponent } from './multisearch/multisearch.component';
import { MyfileModalComponent } from './modals/myfile-modal/myfile-modal.component';
import { SingleCheckoutComponentComponent } from './modals/single-checkout-component/single-checkout-component.component';
import { SignaturePadComponent } from './modals/signature-pad/signature-pad.component';
import { SignatureRequestModalComponent } from './modals/signature-request/signature-request-modal/signature-request-modal.component';
import { PdfViewerComponent } from './modals/pdf-viewer/pdf-viewer.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { UserSignaturePadModalComponent } from './modals/user-signature-pad-modal/user-signature-pad-modal.component';
import { UserListComponent } from './list-views/user-list/user-list.component';
import { UserModalComponent } from './modals/user-modal/user-modal.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserPermissionModalComponent } from './modals/user-permission-modal/user-permission-modal.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AddressComponent } from './address/address.component';
import { ContactListComponent } from './list-views/contact-list/contact-list.component';
import { ClientListComponent } from './list-views/client-list/client-list.component';
import { ContactModalComponent } from './modals/contact-modal/contact-modal.component';
import { InviteModalComponent } from './modals/invite-modal/invite-modal.component';
import { MomentModule } from 'ngx-moment';
import { PdfViewerModalComponent } from './modals/pdf-viewer-modal/pdf-viewer-modal.component';
import { PaymentListComponent } from './list-views/payment-list/payment-list.component';
import { PaymentListDirective } from './list-views/payment-list/payment-list.directive';
import { InvoiceMyfileModalComponent } from './modals/invoice-myfile-modal/invoice-myfile-modal.component';
import { ChequeMyfileModalComponent } from './modals/cheque-myfile-modal/cheque-myfile-modal.component';
import { ModalTaskBarComponent } from './modal-task-bar/modal-task-bar.component';
import { InvoiceListComponent } from './list-views/invoice-list/invoice-list.component';
import { LoginComponent } from '../account/login/login.component';
import { FiniteStateMachineListComponent } from './list-views/finite-state-machine-list/finite-state-machine-list.component';
import { FiniteStateMachineModalComponent } from './modals/finite-state-machine-modal/finite-state-machine-modal.component';
import { ContactPicklistComponent } from './list-views/contact-picklist/contact-picklist.component';
import { ContactListDropdownComponent } from './list-views/contact-list-dropdown/contact-list-dropdown.component';
import { ClientListDropdownComponent } from './list-views/client-list-dropdown/client-list-dropdown.component';
import { ClientPicklistComponent } from './list-views/client-picklist/client-picklist.component';
import { TimelineNoteListComponent } from './list-views/timeline-note-list/timeline-note-list.component';
import { RequisitionListCheckOutComponent } from './list-views/requisition-list-check-out/requisition-list-check-out.component';
import { AuditLogListComponent } from './list-views/audit-log-list/audit-log-list.component';
import { NotificationsListComponent } from './list-views/notifications-list/notifications-list.component';
import { TaskModalComponent } from './modals/task-modal/task-modal.component';
import { TaskListComponent } from './list-views/task-list/task-list.component';
import { NotificationsExtendedComponent } from './list-views/notifications-extended/notifications-extended.component';
import { ImportEntitiesComponent } from './list-views/import-entities-list/import-entities.component';
import { NotificationViewModalComponent } from './modals/notification-view-modal/notification-view-modal.component';
import { CdkDrag, CdkDragPlaceholder, CdkDropList, CdkDragHandle } from '@angular/cdk/drag-drop';
import { ListLayoutComponent } from './list-views/list-layout/list-layout.component';
import { ListAdjustmentModalComponent } from './list-views/list-layout/list-adjustment-modal/list-adjustment-modal.component';
import { CalendarEventModalComponent } from './modals/calendar-event-modal/calendar-event-modal.component';
import { AttendeesSelectionComponent } from './attendees-selection/attendees-selection.component';
import { NgSelectLayoutComponent } from './ng-select-layout/ng-select-layout.component';
import { NgSelectLayoutFilterComponent } from './ng-select-layout-filter/ng-select-layout-filter.component';
import { AIChatBoxComponent } from './modals/aichat-box/aichat-box.component';
import { AccountingConfigurationComponent } from './modals/accounting-configuration/accounting-configuration.component';
import { AccountingConfigurationsListComponent } from './list-views/accounting-configurations-list/accounting-configurations-list.component';
import { AccountingMappingRulesListComponent } from './list-views/accounting-mapping-rules-list/accounting-mapping-rules-list.component';
import { ResizableModalComponentComponent } from './modals/resizeable-modal-component/resizable-modal-component.component';
import { TagControllerModalComponent } from './modals/tag-controller-modal/tag-controller-modal.component';
import { CreateBlogModalComponent } from './modals/create-blog-modal/create-blog-modal.component';
import { SearchKeywordsModalComponent } from './modals/search-keywords-modal/search-keywords-modal.component';
import { ViewBlogModalComponent } from './modals/view-blog-modal/view-blog-modal.component';

import { RichTextEditorComponent } from './rich-text-editor/rich-text-editor.component';
import { RichTextDisplayerComponent } from './rich-text-displayer/rich-text-displayer.component';
import { MarketplaceModalComponent } from './modals/marketplace-modal/marketplace-modal.component';
import { AccordionCustomFieldDisplayerComponent } from './accordian-custom-field-displayer/accordian-custom-field-displayer.component';
import { BillingListComponent } from './list-views/billing-list/billing-list.component';
import { ImageViewerComponent } from './modals/image-viewer/image-viewer.component';
import { AssigneeModalComponent } from './modals/assignee-modal/assignee-modal.component';
import { CustomToolTipsComponent } from './custom-tool-tips/custom-tool-tips.component';
import { DocumentTemplatesEditModalComponent } from './modals/document-templates-edit-modal/document-templates-edit-modal.component';
import { EmailTemplatesListComponent } from './list-views/email-templates-list/email-templates-list.component';
import { EmailTemplateModalComponent } from './modals/email-template-modal/email-template-modal.component';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = { //for some reason the Defualt Drop zone control for Modal's is in Ecommerce 

  // Where we should send the files (Default: null)
  url: environment.apiUrl + "/FileService/UploadStagingFile",

  // Whether the queue will be processed automatically
  autoProcessQueue: true,

  // How many file uploads to process in parallel (Default: null)
  parallelUploads: 1,

  // Name of the file parameter that gets transferred (Default: 'file')
  paramName: 'files',

  // Maximum file size for the upload files in megabytes (Default: null)
  maxFilesize: 250,

  // Comma separated list of mime types or file extensions (Default: null)
  acceptedFiles: '.txt, .pdf, .jpg, .gif, .doc, .docx, .xls, .xlsx, .csv, .jpeg, .png, .zip, .rar, .mp4',

  // Whether to send multiple files in one request (Default: null)
  uploadMultiple: true,

  // Whether thumbnails for images should be generated
  createImageThumbnails: true,

  // Whether to add a link to every file preview to remove or cancel (if already uploading) the file
  addRemoveLinks: true,
};

@NgModule({
  declarations: [
    BlogComponent,
    BreadcrumbsComponent,
    CandidateComponent,
    CategoriesComponent,
    ClientLogoComponent,
    CollectionComponent,
    ContactComponent,
    CounterComponent,
    CtaComponent,
    DesignedComponent,
    DiscoverComponent,
    FaqsComponent,
    FeaturesComponent,
    FindjobsComponent,
    FooterComponent,
    JobcategoriesComponent,
    JobFooterComponent,
    MarketPlaceComponent,
    PlanComponent,
    ProcessComponent,
    ReviewComponent,
    ScrollspyDirective,
    ServicesComponent,
    TeamComponent,
    TopCreatorComponent,
    WalletComponent,
    WorkProcessComponent,
    ContactListComponent,
    ClientModalComponent,
    PicklistModalComponent,
    RequisitionModalComponent,
    FileUploadModalComponent,
    FileManagementComponent,
    DocumentViewModalComponent,
    RequisitionListComponent,
    TimelineModalComponent,
    TimelineNoteModalComponent,
    CheckoutModalComponent,
    InvoiceLineItemModalComponent,
    CreditcardComponent,
    TimeLineListComponent,
    MultiSearchComponent,
    MyfileModalComponent,
    SingleCheckoutComponentComponent,
    SignaturePadComponent,
    SignatureRequestModalComponent,
    PdfViewerComponent,
    UserSignaturePadModalComponent,
    UserListComponent,
    UserModalComponent,
    UserProfileComponent,
    UserPermissionModalComponent,
    AddressComponent,
    ClientListComponent,
    ContactModalComponent,
    InviteModalComponent,
    PdfViewerModalComponent,
    PaymentListComponent,
    PaymentListDirective,
    InvoiceMyfileModalComponent,
    ChequeMyfileModalComponent,
    ModalTaskBarComponent,
    InvoiceListComponent,
    LoginComponent,
    FiniteStateMachineListComponent,
    FiniteStateMachineModalComponent,
    ContactPicklistComponent,
    ContactListDropdownComponent,
    ClientListDropdownComponent,
    ClientPicklistComponent,
    TimelineNoteListComponent,
    RequisitionListCheckOutComponent,
    AuditLogListComponent,
    NotificationsListComponent,
    TaskModalComponent,
    TaskListComponent,
    NotificationsExtendedComponent,
    ImportEntitiesComponent,
    NotificationViewModalComponent,
    ListLayoutComponent,
    ListAdjustmentModalComponent,
    CalendarEventModalComponent,
    AttendeesSelectionComponent,
    NgSelectLayoutComponent,
    NgSelectLayoutFilterComponent,
    AIChatBoxComponent,
    AccountingConfigurationComponent,
    AccountingConfigurationsListComponent,
    AccountingMappingRulesListComponent,
    ResizableModalComponentComponent,
    TagControllerModalComponent,
    CreateBlogModalComponent,
    SearchKeywordsModalComponent,
    ViewBlogModalComponent,
    RichTextEditorComponent,
    RichTextDisplayerComponent,
    MarketplaceModalComponent,
    AccordionCustomFieldDisplayerComponent,
    BillingListComponent,
    ImageViewerComponent,
    AssigneeModalComponent,
    CustomToolTipsComponent,
    DocumentTemplatesEditModalComponent,
    EmailTemplatesListComponent,
    EmailTemplateModalComponent
  ],
  imports: [
    NgxSummernoteModule,
    ArchwizardModule,
    AutocompleteLibModule,
    ColorPickerModule,
    CommonModule,
    CountToModule,
    CRMRoutingModule,
    DropzoneModule,
    FlatpickrModule,
    FormsModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbModule,
    NgbNavModule,
    NgbPaginationModule,
    NgbTooltipModule,
    NgbTypeaheadModule,
    NgSelectModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxSliderModule,
    NgxUsefulSwiperModule,
    ReactiveFormsModule,
    UiSwitchModule,
    MatProgressSpinnerModule,
    NgxExtendedPdfViewerModule,
    MatTreeModule,
    MatButtonModule,
    MatIconModule,
    MomentModule,
    CdkDropList,
    CdkDrag,
    CdkDragPlaceholder,
    CdkDragHandle,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    TitleCasePipe,
    DatePipe,
    provideNgxMask(),
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    }
  ],
  exports: [BreadcrumbsComponent,
    BlogComponent,
    CandidateComponent,
    CategoriesComponent,
    ClientLogoComponent,
    ClientModalComponent,
    CollectionComponent,
    ContactComponent,
    CounterComponent,
    CtaComponent,
    DesignedComponent,
    DiscoverComponent,
    FaqsComponent,
    FeaturesComponent,
    FileUploadModalComponent,
    FindjobsComponent,
    JobcategoriesComponent,
    JobFooterComponent,
    MarketPlaceComponent,
    PicklistModalComponent,
    PlanComponent,
    ProcessComponent,
    RequisitionModalComponent,
    ReviewComponent,
    RouterModule,
    ScrollspyDirective,
    ServicesComponent,
    TeamComponent,
    TopCreatorComponent,
    WalletComponent,
    WorkProcessComponent,
    FileManagementComponent,
    RequisitionListComponent,
    TimelineModalComponent,
    TimelineNoteModalComponent,
    CheckoutModalComponent,
    CreditcardComponent,
    MultiSearchComponent,
    TimeLineListComponent,
    SignaturePadComponent,
    PdfViewerComponent,
    UserSignaturePadModalComponent,
    UserListComponent,
    UserModalComponent,
    UserProfileComponent,
    AddressComponent,
    ContactListComponent,
    ClientListComponent,
    ContactModalComponent,
    InviteModalComponent,
    ModalTaskBarComponent,
    InvoiceListComponent,
    LoginComponent,
    CustomToolTipsComponent,
    FiniteStateMachineListComponent,
    ContactPicklistComponent,
    ContactListDropdownComponent,
    ClientListDropdownComponent,
    ClientPicklistComponent,
    TimelineNoteListComponent,
    RequisitionListCheckOutComponent,
    AuditLogListComponent,
    NotificationsListComponent,
    TaskListComponent,
    NotificationsExtendedComponent,
    ImportEntitiesComponent,
    ListLayoutComponent,
    AttendeesSelectionComponent,
    NgSelectLayoutComponent,
    NgSelectLayoutFilterComponent,
    AccountingConfigurationsListComponent,
    AIChatBoxComponent,
    AccountingMappingRulesListComponent,
    CreateBlogModalComponent,
    RichTextEditorComponent,
    RichTextDisplayerComponent,
    AccordionCustomFieldDisplayerComponent,
    BillingListComponent,
    EmailTemplatesListComponent,
    PaymentListComponent,
    PaymentListDirective,
  ]
})
export class SharedModule { }
